import React, { useEffect } from "react";
import SideMenu from "./SideMenu";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useLocation } from "react-router-dom";

function Sidebar() {
  const location = useLocation();

  const hideOffcanvas = () => {
    if (typeof document === "undefined") return;
    const offcanvasEl = document.getElementById("sidebarMenu");
    const hadBackdrop = Boolean(document.querySelector(".offcanvas-backdrop"));
    const hadShow = Boolean(offcanvasEl?.classList.contains("show"));
    if (offcanvasEl) {
      const bootstrap = window.bootstrap;
      if (bootstrap?.Offcanvas) {
        const instance =
          bootstrap.Offcanvas.getInstance(offcanvasEl) ||
          bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
        instance.hide();
      } else {
        offcanvasEl.classList.remove("show");
      }
    }
    document
      .querySelectorAll(".offcanvas-backdrop")
      .forEach((node) => node.remove());
    if (hadBackdrop || hadShow) {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        hideOffcanvas();
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    hideOffcanvas();
  }, [location.key]);

  return (
    <div>
      <div className="d-none d-lg-block">
        <SideMenu />
      </div>
      <div className="d-lg-none">
        <div>
          <div
            className="offcanvas offcanvas-start"
            tabIndex="-1"
            id="sidebarMenu"
            aria-labelledby="sidebarMenuLabel"
          >
            <div className="p-1" style={{ width: "100%" }}>
              <a href="/" className="me-6 text-white text-decoration-none">
                <span className="fs-4">eCoO</span>
              </a>
              {/* <button type="button" className="btn-close" data-bs-dismiss="offcanvas" style={{ color: "#ffffff", horizontalAlign: "right" }} aria-label="Close">X</button> */}
            </div>
            <div>
              <SideMenu />
            </div>
          </div>
          <button
            className="btn btn-primary floating-button"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#sidebarMenu"
            aria-controls="sidebarMenu"
          >
            <i className="bi-list" style={{ fontSize: "30px" }}></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
